/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { ProgressIndicator } from '@ba/ba-ui-carbon-toolkit';
import Empty from './Empty';
import StringResources from 'nls/StringResources';

import './loading.scss';

class Loading extends Component {

	render() {
		const {
			size,
			...emptyProps
		} = this.props;
		return (
			<div className="explore__loading__container">
				<Empty
					icon={<ProgressIndicator className="explore__loading__icon" size={size} />}
					{...emptyProps}
				/>
				{this._renderCancelButton()}
			</div>
		);
	}

	_renderCancelButton(){
		if(this.props.enableCancel){
			return (
				<div>
					<div className="explore__loading__container__cancelText" onClick={this.props.cancelHandler}>
						{StringResources.get('relationshipGraph_cancel_request')}
					</div>
				</div>
			);
		}
	}
}

const {
	...propTypes
} = Empty.propTypes;

Loading.propTypes = propTypes;
Loading.propTypes.size = PropTypes.string;


Loading.defaultProps = {
	size: 'large'
};

export default Loading;



// WEBPACK FOOTER //
// ./src/js/components/empty/Loading.js